import { EntityType } from "@mapmycustomers/shared/enum";

const keyByEntityType: Record<string, string[]> = {
  [EntityType.ACTIVITY]: ["Activities"],
  [EntityType.COMPANY]: ["Companies"],
  [EntityType.DEAL]: ["Deals"],
  [EntityType.PERSON]: ["People"],
};
const getFeaturePathByEntityType = (key?: string, defaultValue?: string[]): string[] =>
  key && key in keyByEntityType ? keyByEntityType[key] : defaultValue || [];

export default getFeaturePathByEntityType;
